export function FollowedCourseArrowIcon({
  direction,
  className = "size-12 p-2.25",
}: {
  direction: 1 | -1
  className?: string
}) {
  return (
    <svg
      aria-hidden="true"
      className={`${className} rounded-[3.75rem] fill-current transition-[fill] duration-200`}
      viewBox="0 0 512 512"
    >
      <path
        d={
          direction === -1
            ? "M333 128.4L300.7 96 141 256l159.7 160 32.3-32.4L205.7 256z"
            : "M185 128.4L217.3 96 377 256 217.3 416 185 383.6 312.3 256z"
        }
      />
    </svg>
  )
}
